import { Button, Stack, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import { formatDuration } from '../call-duration';
import { downloadRecording } from './storage';
import { i18n } from '@/i18n';

export type LocalRecordingInterruption = 'storage' | 'recorder';

export function notifySaved({
    blob,
    name,
    interruption,
    seconds,
}: Readonly<{ blob: Blob; name: string; interruption: LocalRecordingInterruption | undefined; seconds: number }>) {
    const text = interruption
        ? i18n.t(`conference:recording.notify.localInterrupted.${interruption}`, { time: formatDuration(seconds) })
        : i18n.t('conference:recording.notify.localSaved.message', { name, size: (blob.size / 1024 / 1024).toFixed(1) });
    notifications.show({
        color: interruption ? 'danger' : 'success',
        autoClose: interruption ? false : 8000,
        title: interruption
            ? i18n.t('conference:recording.notify.localInterrupted.title')
            : i18n.t('conference:recording.notify.localSaved.title'),
        message: (
            <Stack align="flex-start" gap="var(--spacing-2)">
                <Text size="sm">{text}</Text>
                <Button
                    size="sm"
                    variant="default"
                    onClick={() => {
                        downloadRecording(blob, name);
                    }}
                >
                    {interruption
                        ? i18n.t('conference:recording.notify.localInterrupted.download')
                        : i18n.t('conference:recording.notify.localSaved.again')}
                </Button>
            </Stack>
        ),
    });
}
